module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-03-e394f56a26107e2703503b8c5c1f7668.svg";